(function($, undefined) {
	
	'use strict';
	
	var init = function () {
		$('.tooltip-element.tooltip-on-disabled').on('mouseenter', function() {
			var element = $(this);
			if (element.find('button').prop('disabled')) {
				element.find('.tooltip').show();
			} else {
				element.find('.tooltip').hide();
			}
		});
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
